import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccessTime = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.718 7.98499V12.636L15.374 14.865M8.557 3.68699C13.148 1.78499 18.411 3.96599 20.313 8.55699C22.215 13.148 20.034 18.411 15.443 20.313C10.852 22.215 5.589 20.034 3.687 15.443C1.786 10.852 3.966 5.58899 8.557 3.68699Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAccessTime);
export default ForwardRef;
